'use client';

import { type ChangeEvent } from 'react';

import { Switch as MantineSwitch } from '@mantine/core';

interface ISwitch {
  defaultChecked?: boolean;
  checked?: boolean;
  label?: string;
  name?: string;
  disabled?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  dataTestId?: string;
  ariaLabel?: string;
}

export const Switch = ({
  defaultChecked,
  checked,
  label,
  name,
  disabled,
  onChange,
  dataTestId = 'youngones-switch',
  ariaLabel,
}: ISwitch) => (
  <MantineSwitch
    styles={() => ({
      track: {
        'input:disabled + &': {
          backgroundColor: '#0CC2AD',
          borderColor: '#0CC2AD',
        },
        'input:checked': {
          backgroundColor: '#000000',
          borderColor: '#0CC2AD',
        },
      },
      body: { display: 'flex' },
    })}
    defaultChecked={defaultChecked}
    checked={checked}
    label={label}
    data-testid={dataTestId}
    name={name}
    disabled={disabled}
    onChange={(event) => onChange(event)}
    aria-label={ariaLabel}
  />
);

Switch.displayName = 'Switch';
